<template>
  <AdminMenu v-if="showAdminUI" />
  <SiteMenu v-else />
</template>

<script>
import AdminMenu from '@/ui/structure/adminMenu'
import SiteMenu from '@/ui/structure/siteMenu'

export default {
  name: 'MenuWrapper',
  components: {
    AdminMenu,
    SiteMenu
  },
  computed: {
    showAdminUI () {
      return this.$route.meta.requiresAdmin || false
    }
  }
}
</script>
